import React from 'react';

export default function About() {
  return (
    <section>
      <div className="inner">
        <div className="section-label">Who We Are</div>
        <h2 className="section-title">About KJVUSA.org</h2>
        <div className="about-content">
          <p>KJVUSA is a ministry dedicated to the preaching of the gospel of Jesus Christ across America.</p>
          
          <h3>Contact</h3>
          <p>For questions, prayer requests, or to partner with this ministry, please reach out through kjvusa.org.</p>
        </div>
      </div>
    </section>
  );
}
